// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"79872bd7","453":"4aaa5655","732":"57e6abba"}[chunkId] + ".chunk.js";
};